import React from 'react';

// ── Library picker card — clickable grid of Ad Library assets ─────
const LibraryPickerCard = ({ assets, onPick }) => {
  if (!Array.isArray(assets) || assets.length === 0) {
    return <p className="text-xs text-gray-500 italic">Your library is empty.</p>;
  }

  return (
    <div className="mt-1 grid grid-cols-3 gap-1.5">
      {assets.map((asset) => {
        const label = asset.name || asset.prompt || `#${asset.id}`;
        return (
          <button
            key={asset.id}
            onClick={() => onPick(asset)}
            title={label}
            className="relative rounded-xl border border-gray-200 overflow-hidden bg-gray-100 hover:border-[#221C51] hover:shadow-md transition group"
            style={{ aspectRatio: '1 / 1' }}
          >
            {asset.type === 'video' ? (
              <video
                src={asset.url}
                muted
                preload="metadata"
                className="w-full h-full object-cover"
              />
            ) : (
              <img
                src={asset.url}
                alt={label}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            )}
            {asset.type === 'video' && (
              <span className="absolute top-1 right-1 text-xs bg-black/60 text-white rounded-full px-1.5 py-0.5">
                🎬
              </span>
            )}
            <span className="absolute bottom-0 left-0 right-0 bg-black/55 text-white text-[10px] px-1.5 py-0.5 truncate text-left opacity-0 group-hover:opacity-100 transition">
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default LibraryPickerCard;
